import React, {useContext, useRef, useState, useEffect} from 'react'
import {ShortcutContext} from "@common/context/ShortcutContext";
import MenuButton from "./MenuButton";
import {
    BookmarksIcon,
    NotificationsIcon,
    SearchIcon,
    SettingsIcon,
    AdminSettingsIcon,
    HelpIcon,
    SpeechHelpIcon,
    PinIcon,
    GoIcon,
    ReportsIcon,
    CogIcon,
    LogoutIcon
} from "@common/icons";
import Brands from "./Brands";
import Bookmarks from "./Bookmarks";
import Notifications from "./NotificationsDevelopment";
import Search from "./Search";
import UserDropdown from "./UserDropdown";
import ChildMenu from "./ChildMenu";
import ActForUser from "./ActForUser";
import AdminSchoolSelector from "./AdminSchoolSelector";
import {BrandContext} from "@context/BrandContext";
import {UserContext} from "@context/UserContext";
import NavigationDrawer from "./NavigationDrawer";
import CircularLoader from "@common/CircularLoader";
import {ContentContext} from "@context/ContentContext";
import useCurrentShortcut from "@hooks/useCurrentShortcut";
import StudentDiagnosticMenuWidget from "../diagnosticReporting/StudentDiagnosticMenuWidget"
import useOnClickOutside from "@hooks/useOnClickOutside";
import UserReview from "../review/UserReview";
import CMSSearch from "../cms/CMSSearch";
import PromptSearch from "./PromptSearch";
import {NavigationContext} from "@common/context/NavigationContext";
import ButtonsGroup from "@common/ButtonsGroup";

const TitleNavigationDevelopment = () => {
    const { globalShortcuts } = useContext(ShortcutContext);
    const brandConfig = useContext(BrandContext);
    const {user, userLoading, isOpenPinnedMenu, setOpenPinnedMenu} = useContext(UserContext);
    const {contentLoading, contentSaving, contentEditing} = useContext(ContentContext);
    const titleNavigationNames = ['Brands', 'Bookmarks', 'Search resources', 'Search prompt', 'CMS Search', 'Notifications', 'Bookmarks', 'Admin settings', 'Test follow-up work', 'Return to GO'];
    const [titleNavigationItems, setTitleNavigationItems] = useState([]);
    const { drawerComponentName, setDrawerComponentName, isDrawerVisible, setDrawerVisible } = useContext(NavigationContext);
    const [selectedShortcut, setSelectedShortcut] = useState();
    const [openMenuButton, setOpenMenuButton] = useState();
    const {loadShortcut} = useCurrentShortcut();
    const titleNavigationRef = useRef();
    const drawerTriggerRef = useRef();

    const menuComponents = {
        Bookmarks: Bookmarks,
        Notifications: Notifications,
        Search: Search,
        PromptSearch: PromptSearch,
        Brands: Brands,
        ChildMenu: ChildMenu,
        UserReview: UserReview,
        ActForUser: ActForUser,
        AdminSchoolSelector: AdminSchoolSelector,
        CMSSearch: CMSSearch,
        StudentDiagnosticMenuWidget: StudentDiagnosticMenuWidget,
        UserDropdown: UserDropdown
    };

    const iconComponents = {
        SettingsIcon: SettingsIcon,
        SearchIcon: SearchIcon,
        BookmarksIcon: BookmarksIcon,
        NotificationsIcon: NotificationsIcon,
        AdminSettingsIcon: AdminSettingsIcon,
        HelpIcon: HelpIcon,
        SpeechHelpIcon: SpeechHelpIcon,
        PinIcon: PinIcon,
        GoIcon: GoIcon,
        ReportsIcon: ReportsIcon,
        CogIcon: CogIcon,
        LogoutIcon: LogoutIcon,
    };

    useOnClickOutside(titleNavigationRef, (openMenuButton !== undefined && !isDrawerVisible), () => {
        setOpenMenuButton(undefined);
    });

    const handleMenuClick = shortcut => {
        if (shortcut && openMenuButton !== shortcut.shortcutId) {
            setOpenMenuButton(shortcut.shortcutId);
            setDrawerVisible(false);
            loadShortcut(shortcut);
        } else {
            setOpenMenuButton(undefined);
        }
        if(!shortcut.pinned) {
            setOpenPinnedMenu(false);
        } else {
            setOpenPinnedMenu((prevState) => !prevState);
        }
    }

    const handleDrawerClick = (shortcut, menuComponent, menuComponentName, id) => {
        if (menuComponent === undefined) {
            return;
        }

        if(drawerComponentName === menuComponentName && isDrawerVisible){
            setDrawerVisible(false);
        }else{
            drawerTriggerRef.current = document.activeElement;
            setDrawerVisible(true);
            setOpenMenuButton(undefined);
        }
        setDrawerComponentName(menuComponentName);
        setSelectedShortcut(shortcut);
    }

    const handleClose = () => {
        setOpenMenuButton(undefined);
    }

    if (globalReactFunctions) {
        globalReactFunctions.handleTitleNavMenuClose = handleClose;
    }

    useEffect(() => {
        setTitleNavigationItems(globalShortcuts.filter(shortcut => {if((shortcut.shortcutId == 153 && user?.authorityId != 2) || (shortcut.shortcutId == 177 && !user?.testResultId) || (shortcut.shortcutId == 166 && !user?.demoOrTestSchool)) return false; return titleNavigationNames.includes(shortcut.name)}));
    }, [user, isOpenPinnedMenu]);

    return (
        <nav ref={titleNavigationRef} aria-label={"Global Navigation"} className={"ch-title-navigation"}>
            <CircularLoader visible={userLoading || contentLoading} pageCentered={false} lightStyle={true}/>
            <ButtonsGroup>
                {titleNavigationItems.map(shortcut => {
                    const iconComponentName = (shortcut.iconComponent ? shortcut.iconComponent : 'Default');
                    const iconComponent = iconComponents[iconComponentName];

                    const menuComponentName = (shortcut.menuComponent ? shortcut.menuComponent : undefined);
                    const menuComponent = menuComponents[menuComponentName];
                    const panelId = `nav-panel-${shortcut.shortcutId}`;

                    if (shortcut.actForUser && user.actForUserId == undefined) {
                        return null;
                    } else if (shortcut.multiBrand && (user.brandCodes == undefined || user.brandCodes.length <= 1)) {
                        return null;
                    } else if (shortcut.adminShortcut && !brandConfig.enableAdminShortcuts && !user.adminUser && user.actForUserId == undefined) {
                        return null;
                    }

                    return(
                            <MenuButton
                                id={`title-nav-btn-${shortcut.shortcutId}`}
                                key={shortcut.shortcutId}
                                aria-controls={panelId}
                                tabkey={shortcut.shortcutId}
                                shortcut={shortcut}
                                className={'ch-nav-icon-btn'}
                                menuComponent={menuComponent}
                                menuComponents={menuComponents}
                                menuWidget={shortcut.menuWidget}
                                iconComponent={iconComponent}
                                visible={(openMenuButton === shortcut.shortcutId && !shortcut.pinned) || (shortcut.pinned && isOpenPinnedMenu)}
                                handleClick={handleMenuClick}
                                handleClose={handleClose}
                                placement={'top'}
                                handleDrawerClick={(shortcut) => handleDrawerClick(shortcut, menuComponent, menuComponentName)}
                            />
                        )
                })}
            </ButtonsGroup>
            <UserDropdown
                visible={openMenuButton === 'userDropdown'}
                handleClick={handleMenuClick}
                handleClose={handleClose}
            />
            <NavigationDrawer id={`nav-drawer-${selectedShortcut?.shortcutId}`} visible={isDrawerVisible} callback={() => {setDrawerVisible(false);}} parentMenu={null} componentName={drawerComponentName} triggerButtonRef={drawerTriggerRef}/>
        </nav>
    )
}

export default TitleNavigationDevelopment